/**
 * Componente ThemeToggle
 * Toggle (switch) para alternar entre tema claro e escuro
 */

import React from "react";
import { Switch } from "antd";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../../hooks/useTheme";
import { cn } from "../../lib/utils";

const ThemeToggle = ({ className, showLabel = false }) => {
  const { toggleTheme, isDark } = useTheme();

  return (
    <div className={cn("flex items-center gap-2", className)}>
      {showLabel && (
        <span className="text-sm text-primary-foreground hidden sm:inline">
          {isDark ? "Escuro" : "Claro"}
        </span>
      )}
      <div className="flex items-center gap-2">
        <Sun className={cn("w-4 h-4 transition-colors", isDark ? "text-primary-foreground/40" : "text-primary-foreground/90")} />
        <Switch
          checked={isDark}
          onChange={toggleTheme}
          checkedChildren={
            <div className="flex items-center justify-center h-full">
              {/* <Moon className="w-3 h-3" /> */}
            </div>
          }
          unCheckedChildren={
            <div className="flex items-center justify-center h-full">
              {/* <Sun className="w-3 h-3" /> */}
            </div>
          }
          title={isDark ? "Alternar para tema claro" : "Alternar para tema escuro"}
        />
        <Moon className={cn("w-4 h-4 transition-colors", isDark ? "text-primary-foreground/90" : "text-primary-foreground/40")} />
      </div>
    </div>
  );
};

export default ThemeToggle;

